import axios from 'axios'
import { useUserStore } from 'obst/user-store'
import obfn from '@/utils/obfn'
import obui from '@/utils/obui'
import { isLBE } from '@/utils/obcfg'
import route from '@/utils/obroute'
import i18n from '@/i18n/index.ts'
import { getFullPath } from './obpath'

const t = i18n.global.t

let baseURL
const proxyHost = import.meta.env.VITE_PROXY_HOST
const proxyPath = import.meta.env.VITE_PROXY_PATH

const urlbHost = 'urlb.truemetrics.cn'
if (document.location.hostname == urlbHost) {
  baseURL = `https://api.urlb.truemetrics.cn`
} else if(document.location.hostname == proxyHost) {
  baseURL = `https://${proxyHost}/${proxyPath}/api`
} else {
  // obdev
  // baseURL = `http://192.168.5.163:8000/`
  baseURL = `http://34.45.213.14:88/`
  if (isLBE) {
    baseURL = 'http://localhost:88/api/urlb'
  }
}

const obaxios = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  headers: {
    // "Content-Type": "application/json;charset=utf-8",
    'Content-Type': 'multipart/form-data',
  },
})

// request interceptor
obaxios.interceptors.request.use(
  function (config) {
    const userStore = useUserStore()

    // 设置Token
    if (/^\/task\/(login|validate_email|reset_password_one|register|reset_password_two)/.test(config.url)) {
      config.headers.Authorization = void 0
    } else {
      config.headers.Authorization = `token ${userStore.token}`
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        const part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              const params = propName + '[' + key + ']'
              const subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    if (!isLBE) {
      config.url = `/${t('api_path')}/api${config.url}`
    }
    obfn.log('request_url', config.url)
    return config
  },
  function (error) {
    // obfn.log('axiosReqErr',error)
    return Promise.reject(error)
  },
)

// response interceptor
obaxios.interceptors.response.use(
  //obopt 通用错误提示&具体错误提示
  (response) => {
    const status = response.data?.status
    const msg = response.data?.msg || response.data?.message || response.data?.detail
    if (!status && msg) {
      // 错误信息
      if (msg.trim().startsWith('发生错误')) {
        obui.error(t('error.server'))
      } else {
        obui.error(msg)
      }
    }
    return response
  },
  function (error) {
    const userStore = useUserStore()
    obfn.log('axioxErr', error.response)
    const errRes = error?.response
    const errCode = errRes?.status,
      errText = errRes?.statusText
    const errData = errRes?.data,
      errStatus = errData?.status,
      errMsg = errData?.msg || errData?.detail
    const reqPath = errRes?.config?.url
    obfn.log('errMsg', reqPath + '\n', errMsg)
    obfn.log('errText', errText)
    obfn.log('errStatus', errStatus)

    // 判断是否登录失效
    if (errCode == 401) {
      // 跳转登录页面
      route.navTo('login')
      userStore.tokenSetExpired()
      return Promise.reject(error)
    }
    // 服务器错误
    if (errCode == 500 || errCode == 502) {
      obui.error(t('error.server'))
      return Promise.reject(error)
    }
    //消息提示
    if (error.message && error.message.includes('timeout')) {
      obui.error(t('error.timeout'))
      return Promise.reject({ genericError: 'Timeout' })
    } else {
      obui.error(errMsg)
      return Promise.reject(error)
    }
  },
)

export default obaxios
